import { useTranslation } from "react-i18next";
import React, { useState, useEffect, Fragment, useRef, useLayoutEffect } from "react";
import { useNavigate } from "react-router-dom";
import apiRequest from "../../functions/api";
import {
  Paper,
  Typography,
  Table,
  Hidden,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Button,
  Box,
  Grid,
  Card,
  Toolbar,
  Badge,
  Chip,
  IconButton,
} from "@mui/material";
import LoadingComponent from "../LoadingComponent/LoadingComponent";
import { useMessage } from "../../context/message-context";
import Layout from "../shared/components/LayoutComponent";
import Page from "../shared/components/PageComponent";
import Modulgruppenfilter from "../Modulgruppenfilter/Modulgruppenfilter";
import ResponsiveDialog from "../shared/components/ResponsiveDialog";
import CheckBoxIcon from "@mui/icons-material/CheckBox";
import RefreshIcon from "@mui/icons-material/Refresh";
import { setColor2, roundTo } from "../../functions/default";
import { postMeldungKenntnisnahme } from "./postMeldungKenntnisnahme";
import { SearchTextField } from "../lib";
import { useSessionStorage } from "../../utils/hooks";
import { LOCAL_STORAGE_KEY } from "../../constants/localStorage";

function AbsenceConfirm(props) {
  const { t } = useTranslation();
  const navigate = useNavigate();
  const [antraege, setAntraege] = useState([]);
  const { accessToken, client } = props;
  const [isLoading, setIsLoading] = useState(false);
  const { hideMessage, showErrorMessage } = useMessage();
  const [stellvor, setStellvor] = useState("0");
  const [info, setInfo] = useState(false);
  const [gruppen, setGruppen] = useState([]);
  const [magruppen, setMagruppen] = useState([]);
  const [gruppe, setGruppe] = useState(0);
  const [untergeben, setUntergeben] = useState(0);
  const [filteraktiv, setFilteraktiv] = useState("");
  const [dialog, setDialog] = useState(false);
  const [selectedElement, setSelectedElement] = useState();
  const [noprot, setNoprot] = useState("");
  const [search, setSearch] = useState("");
  const [scrollPosition, setScrollPosition] = useState(() => {
    const storedScrollPosition = localStorage.getItem("scrollPositionAbsenceConfirm");
    return storedScrollPosition ? parseInt(storedScrollPosition, 10) : 0;
  });
  const tableRef = useRef(null);
  const [box1, setBox1] = useSessionStorage(LOCAL_STORAGE_KEY.modulGruppenfilter1);
  const [box2, setBox2] = useSessionStorage(LOCAL_STORAGE_KEY.modulGruppenfilter2);

  useEffect(() => {
    //Wenn in box1 und box2 etwas drin steht, gibt es Werte ausm Localstorage -> dann diese verwenden
    if (magruppen.length === 0) {
      return;
    }
    if (box1 !== "" && box2 !== "") {
      var gefunden = false;
      //Hier prüfen ob die Werte die in LocalStorage als Filter stehen, in diesem Programm überhaupt verfügbar sind.
      magruppen.forEach((item, index) => {
        if (item.key === box1) {
          gefunden = true;
        }
      });
      if (gefunden === true) {
        setGruppe(box2);
        setUntergeben(box1);
      } else {
        //Wenn Werte ausm LocalStorage hier nicht verfügbar sind->Standardfilter auf erste Mitarbeiter auswahl und "alle Gruppen" setzen
        if (magruppen[1]?.key !== undefined) {
          if (!untergeben) {
            setBox1(magruppen[1]?.key);
            setUntergeben(magruppen[1]?.key);
          }
        } else {
          setBox1("D");
          setUntergeben("D");
        }
        setBox2("A");
        setGruppe("A");
      }
      return;
    }
    //Noch keine Standardwerte im localstorage gefunden-> Filter  erste Mitarbeiter auswahl  und "alle Gruppen" setzen
    if (magruppen[1]?.key !== undefined) {
      if (!untergeben) {
        setBox1(magruppen[1]?.key);
        setUntergeben(magruppen[1]?.key);
      }
    } else {
      setBox1("D");
      setUntergeben("D");
    }
    setBox2("A");
    setGruppe("A");

    // eslint-disable-next-line
  }, [magruppen]);

  useEffect(() => {
    sessionStorage.setItem(LOCAL_STORAGE_KEY.modulGruppenfilter1, untergeben);
    // eslint-disable-next-line
  }, [untergeben]);

  useEffect(() => {
    sessionStorage.setItem(LOCAL_STORAGE_KEY.modulGruppenfilter2, gruppe);
    // eslint-disable-next-line
  }, [gruppe]);

  useEffect(() => {
    localStorage.removeItem("AbsenceArchData");
    localStorage.removeItem("AbsenceArchFilter");
  }, []);

  useLayoutEffect(() => {
    // Wartet einen Frame länger damit MUI Table Zeit für den Render hat etc
    requestAnimationFrame(() => {
      if (!tableRef.current) return;
      tableRef.current.scrollTop = scrollPosition;
    });
  }, [antraege, tableRef]);

  const aufgabenLaden = () => {
    setIsLoading(true);
    const payload = {
      mandant: client,
      program: "PMURA3",
      statement: "UEBERSICHT",
    };
    const headers = {
      Authorization: "Bearer " + accessToken,
    };
    apiRequest("POST", "daten", payload, headers, antragCb);
  };

  useEffect(() => {
    aufgabenLaden();
    setSearch(sessionStorage.getItem("search"));
    // eslint-disable-next-line
  }, []);

  const antragCb = (response) => {
    if (response.status === 200) {
      if (response.data.stellv) {
        setAntraege(response.data.stellv);
        setStellvor(response.data.stell_vor);
      } else {
        setAntraege([]);
      }
      setNoprot(response.data.noprot);
      if (response.data.gruppen) {
        setGruppen(response.data.gruppen);
      }
      if (response.data.magruppen) {
        setMagruppen(response.data.magruppen);
      }
      if (response.data.filter) {
        setFilteraktiv(response.data.filter);
      }
      if (response.data.info === "J") {
        setInfo(true);
      } else {
        setInfo(false);
      }
      setIsLoading(false);
      hideMessage();
    } else {
      if (response) {
        showErrorMessage(response.data.message);
      } else {
        showErrorMessage(t("Keine Internetverbindung"));
      }
    }
  };
  const seitenwechsel = (element) => {
    element.art === "ANTRAG" && setRedirect("/PMURA3/antragsdetails/" + "000" + element.key);
    element.art === "KORREKTUR" && setRedirect("/PMURA3/korrekturdetails/" + "000" + element.key);
    element.art === "SZ" && setRedirect("/SPLANT/" + "000" + element.key);
    element.art === "FORM" && setRedirect("/FORANT/" + element.key);
    element.art === "FORMULAR" && setRedirect("/FORMUL/genehmigen/" + element.key);
    if (element.art === "BONUS") {
      showErrorMessage(
        t("Der Entgeltantrag (Tag) ist nur noch in der alten ectool-App verfügbar. Bitte genehmigen Sie diese Alt-Fälle noch über die alte ectool-App"),
      );
    }
    if (element.art === "HABW") {
      setSelectedElement(element);
      setDialog(true);
    }
  };
  const setRedirect = (path) => {
    navigate(path);
  };

  const handleKrankmeldungKenntnisClick = () => {
    if (selectedElement) {
      postMeldungKenntnisnahme(client, accessToken, selectedElement.key.substring(1), selectedElement.von_id)
        .then((data) => {
          aufgabenLaden();
        })
        .catch((err) => {
          showErrorMessage(err);
        })
        .finally(() => {
          setIsLoading(false);
          setDialog(false);
        });
    }
  };

  function handleSearch(e) {
    setSearch(e.target.value);
    sessionStorage.setItem("search", e.target.value);
  }

  const handleScroll = (event) => {
    setScrollPosition(event.target.scrollTop);
    localStorage.setItem("scrollPositionAbsenceConfirm", event.target.scrollTop);
  };

  if (isLoading) {
    return <LoadingComponent />;
  }
  const dataRequest =
    antraege.length > 0 ? (
      antraege.map((stellv) => {
        const antraegeZeichnen = stellv.antraege
          .sort((a, b) => b.bereitsAbgelehnt - a.bereitsAbgelehnt)
          .filter((item, index) => {
            // if (item.art==="FORMULAR") return true
            if (untergeben && untergeben !== "A" && item.untergeben.includes(untergeben) === false) {
              return false;
            }
            if (gruppe && gruppe !== "A" && item.gruppe.includes(gruppe) === false) {
              return false;
            }
            return true;
          })
          .map((element) => {
            if (!search || (element.typ + element.von).toLowerCase().includes(search.toLowerCase())) {
              return (
                <TableRow key={element.key} style={{ cursor: "pointer" }} onClick={() => seitenwechsel(element)} hover>
                  <Hidden smDown>
                    <TableCell> {element.fuer_annr !== "" && <Chip color="default" label={element.fuer_annr} />}
                      {element.bereitsAbgelehnt === "1" && <Chip color="warning" label="Korrigierter Antrag" />}
                      <Typography> {element.typ}</Typography>
                     
                    </TableCell>
                    <TableCell>{element.von}</TableCell>
                    <TableCell>{element.gestellt === "00.00.0000" ? "*" : element.gestellt}</TableCell>
                    <TableCell>{element.zeitraum}</TableCell>
                    <TableCell>{element.untergeben.includes("S") ? <CheckBoxIcon /> : ""}</TableCell>
                  </Hidden>
                  <Hidden smUp>
                    <TableCell>
                      {element.bereitsAbgelehnt === "1" && <Chip color="warning" label="Korrigierter Antrag" />}
                      <Typography variant="body1">{element.typ}</Typography>
                      <Typography variant="body1">{element.von}</Typography>
                      <Typography variant="body2">{element.gestellt === "00.00.0000" ? "*" : element.gestellt}</Typography>
                      <Typography variant="body2">{element.zeitraum}</Typography>
                      <Typography style={{ color: setColor2("255100100", 1) }}>{element.untergeben.includes("S") ? "in Stellvertretung" : ""}</Typography>
                    </TableCell>
                  </Hidden>
                </TableRow>
              );
            }
          });
        return (
          <Fragment>
            <Hidden smDown>
              <TableHead>
                {/*  stellvor==="1" &&
          <TableRow>
            <TableCell colSpan={5}>
            <Typography variant="h6">
              { stellv.name === "Eigene" ?
                  "Meine Mitarbeiter"
                :
                  "Stellvertretend für " + stellv.name    
              }    
            </Typography> 
            </TableCell>
          </TableRow>
            */}
              </TableHead>
            </Hidden>
            <Hidden smUp>
              <TableHead>
                {/*stellvor==="1" &&
          <TableRow>
            <TableCell>              
              { stellv.name === "Eigene" ?
                  "Meine Mitarbeiter"
                :
                  "Stellvertretend für " + stellv.name    
              } </TableCell>
            </TableRow>
            */}
              </TableHead>
            </Hidden>
            <TableBody>{antraegeZeichnen}</TableBody>
          </Fragment>
        );
      })
    ) : (
      <TableRow>
        <Hidden smUp>
          <TableCell>
            <Typography variant="body1">{t("Es wurden keine offenen Anträge gefunden")}</Typography>
          </TableCell>
        </Hidden>
        <Hidden smDown>
          <TableCell colSpan={5}>
            <Typography variant="body1">{t("Es wurden keine offenen Anträge gefunden")}</Typography>
          </TableCell>
        </Hidden>
      </TableRow>
    );
  return (
    <Page>
      <Layout fullWidth>
        <Hidden smDown>
          <Box p={2}>
            <Typography color="primary" variant="h4">
              {t("Offene Meldungen/Anträge Ihrer Mitarbeiter")}
            </Typography>
          </Box>
        </Hidden>
      </Layout>
      <Grid container justifyContent="center">
        <Grid item xs={12} md={10} lg={8}>
          <Grid container justifyContent="flex-start" alignItems="center" spacing={1}>
            {filteraktiv === "J" && (
              <Grid item xs={12}>
                <Card>
                  <Modulgruppenfilter
                    gruppen={gruppen}
                    onMitarbeiterChange={setUntergeben}
                    onGruppeChange={setGruppe}
                    selectedGruppe={gruppe}
                    small={true}
                    kz="full"
                    mitarbeiter={magruppen}
                    selectedMitarbeiter={untergeben}
                  />
                  <Toolbar>
                    <form style={{ flexGrow: 1 }}>
                      <Box pb={1}>
                        <SearchTextField
                          size="small"
                          fullWidth
                          label={t("Suche")}
                          id="search"
                          variant="outlined"
                          value={search}
                          inputProps={{
                            autoCapitalize: "off",
                            autoCorrect: "off",
                            spellCheck: "false",
                            autoComplete: "off",
                          }}
                          onChange={(e) => {
                            handleSearch(e);
                          }}
                        />
                      </Box>
                    </form>
                    <IconButton color="primary" onClick={aufgabenLaden}>
                      <RefreshIcon />
                    </IconButton>
                  </Toolbar>
                </Card>
              </Grid>
            )}

            <Grid item xs={12}>
              <Card>
                <Box p={2}>
                  <TableContainer ref={tableRef} onScroll={handleScroll} sx={{ maxHeight: window.innerHeight - 500 }} component={Paper}>
                    <Table stickyHeader>
                      <Hidden smDown>
                        <TableHead>
                          <TableRow>
                            <TableCell>{t("Art des Antrags")}</TableCell>
                            <TableCell>{t("Antragsteller")}</TableCell>
                            <TableCell>{t("Beantragt am")}</TableCell>
                            <TableCell>{t("Antragszeitraum")}</TableCell>
                            <TableCell>{t("in Stellvertretung")}</TableCell>
                          </TableRow>
                        </TableHead>
                      </Hidden>
                      {dataRequest}
                    </Table>
                  </TableContainer>
                </Box>
              </Card>
            </Grid>
            {info && (
              <Grid item xs={12}>
                <Box pb={2} pl={2} pr={2}>
                  <Typography>{t("* Antragsdatum nicht verfügbar (ab nächster Version)")}</Typography>
                </Box>
              </Grid>
            )}
            <Grid item xs={12}>
              <Box pb={2} pl={2} pr={2}>
                <Button
                  onClick={() => {
                    if (noprot === "J") {
                      showErrorMessage("Es sind keine protokollierten Aktionen vorhanden");
                    } else {
                      navigate("/PMURA3/protokoll");
                    }
                  }}
                  variant="contained"
                  sx={{ margin: 2 }}
                  color="primary"
                >
                  {t("Log anzeigen")}
                </Button>

                <Button
                  onClick={() => {
                    if (noprot === "J") {
                      showErrorMessage("Es sind keine protokollierten Aktionen vorhanden");
                    } else {
                      navigate("/PMURA3/archiv");
                    }
                  }}
                  variant="contained"
                  sx={{ margin: 2 }}
                  color="primary"
                >
                  {t("Archiv anzeigen")}
                </Button>
              </Box>
            </Grid>
          </Grid>
        </Grid>
      </Grid>
      <ResponsiveDialog
        title={t("Arbeitsunfähigkeit zur Kenntnis genommen?")}
        open={dialog}
        setOpen={(o) => {
          setDialog(false);
        }}
      >
        <Box p={1}>
          <Grid container justifyContent="center">
            <Grid item xs={12}>
              <Grid container justifyContent="center" spacing={2}>
                <Grid item xs={12} sm={6}>
                  <Button color="primary" variant="outlined" fullWidth onClick={() => setDialog(false)}>
                    {t("Abbrechen")}
                  </Button>
                </Grid>
                <Grid item xs={12} sm={6}>
                  <Button variant="contained" color="primary" fullWidth onClick={handleKrankmeldungKenntnisClick}>
                    {t("Zur Kenntnis genommen")}
                  </Button>
                </Grid>
              </Grid>
            </Grid>
          </Grid>
        </Box>
      </ResponsiveDialog>
    </Page>
  );
}
export default AbsenceConfirm;
